<template>
  <div v-if="isHideRevenue !== undefined" class="wrapper">
    <div v-if="isHideRevenue">本ページへのアクセス権がありません</div>
    <v-container v-if="!isHideRevenue" ma-0 fluid>
      <Section class="mb-3 pa-0">
        <v-toolbar flat color="white">
          <v-flex xs3>
            <ServeStatusFilter :value="filter.serveStatus" class="mr-2" />
          </v-flex>
          <v-flex xs3>
            <KeywordFilter v-model="keyword" />
          </v-flex>
          <v-spacer />
          <v-flex xs3>
            <PageSelect :value="searchResult" @input="onChangePageNo" />
          </v-flex>
        </v-toolbar>
      </Section>
      <div>
        <IOTable
          :items="searchResult.items || []"
          :sort-options="sortOptions"
          :loading="loading"
        />
      </div>
    </v-container>
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeLoginLp } from '@/mixins/setDrawerTypeLoginLp'
import { setToolBarTypeLoginLp } from '@/mixins/setToolBarTypeLoginLp'
import IOTable from '@/components/LoginLp/Operation/IOTable'
import ServeStatusFilter from '@/components/LoginLp/Operation/ServeStatusFilter'
import KeywordFilter from '@/components/Shared/Search/KeywordFilter'
import PageSelect from '@/components/Shared/Search/PageSelect'
import Section from '@/components/Shared/Section/Section'
import { actions, getters } from '@/vuex/modules/dashboard/constants'
import { Account } from '@/models/Account'

export default {
  name: 'Operation',
  components: {
    IOTable,
    ServeStatusFilter,
    KeywordFilter,
    PageSelect,
    Section,
  },
  mixins: [accountInitializer, setDrawerTypeLoginLp, setToolBarTypeLoginLp],
  data() {
    return {
      isHideRevenue: undefined,
    }
  },
  computed: {
    searchResult() {
      return this.$store.getters[getters.searchResult]
    },
    loading() {
      return this.$store.getters[getters.loading]
    },
    sortOptions() {
      return this.$store.getters[getters.sortOptions]
    },
    filter() {
      return this.$store.getters[getters.filter]
    },
    keyword: {
      get() {
        return this.filter.keyword
      },
      set(value) {
        this.$store.dispatch(actions.UPDATE_KEYWORD_FILTER, value)
      },
    },
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userType() {
      return this.$store.getters['account/userType']
    },
  },
  watch: {
    sortOptions: {
      handler() {
        this.search()
      },
      deep: true,
    },
    filter: {
      handler() {
        this.search()
      },
      deep: true,
    },
    userBelongType() {
      this.setIsHideRevenue()
    },
  },
  created() {
    this.search()
    this.setIsHideRevenue()
  },
  methods: {
    async setIsHideRevenue() {
      if (!this.userBelongType || !this.userBelongId) return

      this.isHideRevenue = await Account.isHideRevenue(
        this.userBelongType,
        this.userBelongId,
        this.userType,
      )
    },
    async search() {
      await this.$store.dispatch(actions.SEARCH)
    },
    onChangePageNo(pageNo) {
      this.$store.dispatch(actions.UPDATE_PAGE, { pageNo })
      this.search()
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
</style>
